
export enum BannerTypes {
  LINK_TO_PAGE = "LINK_TO_PAGE",
  POPUP = "POPUP"
};
